import { updateUserJamStateReq } from "../../Request.d";
import { setNotificationMessage } from "./payment-reducer/actions";
import { dispatch } from "../../../Utils";
import { Translate } from "../../../../webjam/language";
import { ct } from "../../../constant-Utils";

export const PaymentPages = {
    INVITATION_LIST: "Invitation list",
    ROOM_LIST: "Room list",
    CREATE_ROOM: "Create room",
    UPDATE_ROOM: "Update room",
    HOSTED_ROOM: "My rooms",
    INVITED_ROOM: "Other rooms",
    MY_CONTACT: "My contact",
    CONTACT_LIST: "Contact list",
    CONTACT_GROUP: "Contact group",
    SUBSCRIPTION: "Subscription",
    MY_RECORDINGS: "My Recordings",
    RTA_SOCIAL_NETWORK: "RTA Social Network",
    PAYMENT_HISTORY: "Payment history",
    MY_DEVICE: "My Devices"
}

export const filterString = (string) => string;

export const makePassword = (length = 6) => {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

export const SEARCH_DELAY_TIME = 1000;

export const LEFT_MENU_WIDTH = 300;

export const RoomCategory = [
    "Uncategorized",
    "Music",
    "Vocal",
    "Training",
    "Singing"
]


export const NotificationType = {
    ERROR: "error",
    SUCCESS: "success",
    INFO: "info"
}

export const paginationObject = {
    count: 0,
    page: {
        currentPage: 0,
        nextPage: 0,
        perPage: 0,
        prevPage: 0,
        totalPage: 0
    }
}


export const subscriptionObj = {
    end_at: 0,
    is_canceled: false,
    name: null,
    amount: 0,
    status: false,
    subscription_id: null,
    trial_started: 0,
    trial_ended: 0,
    start_at: 0,
    canceled_at: null,
    _id: null,
    pack_id: null,
    package_type: "",
    is_premium: false,
    coupon_code_id: null,
    isActive: false
}

export const RoomOccurenceType = {
    DAILY: "DAILY",
    WEEKLY: "WEEKLY",
    MONTHLY: "MONTHLY"
}


export const RoomDuration = 11;
export const RoomDurationDays = 30;
export const RoomDurationWeeks = 12;
export const RoomDurationMonth = 12;

export const RoomOccurenceWeekDays = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
]


export const WeekDayNames = {
    MONDAY: "MONDAY",
    TUESDAY: "TUESDAY",
    WEDNESDAY: "WEDNESDAY",
    THURSDAY: "THURSDAY",
    FRIDAY: "FRIDAY",
    SATURDAY: "SATURDAY",
    SUNDAY: "SUNDAY"
}

export const WeekNumber = {
    FIRST: "FIRST",
    SECOND: "SECOND",
    THIRD: "THIRD",
    FOURTH: "FOURTH",
    LAST: "LAST"
}

export const MonthType = {
    ONCE: "ONCE",
    MULTIPLE: "MULTIPLE"
}

export const updateJammingCapability = async (jammingInfo = [], room_name, status) => {
    try {
        let is_match_roomname = false;
        let res = await updateUserJamStateReq({
            jamming_capability: status,
            room_name: room_name
        })
        if (res.status == 1) {
            dispatch(
                setNotificationMessage({
                    isOpen: true,
                    type: NotificationType.SUCCESS,
                    message: ct("Translate.messages.updateJammingStatusSuccess")
                })
            );
        } else {
            dispatch(
                setNotificationMessage({
                    isOpen: true,
                    type: NotificationType.ERROR,
                    message: ct("Translate.messages.updateJammingStatusFail")
                })
            );
        }

        if (jammingInfo.length) {
            jammingInfo.map(val => {
                if (val.room_name == room_name) {
                    val.status = status;
                    is_match_roomname = true;
                }
            })
        }

        if (!is_match_roomname && Array.isArray(jammingInfo)) {
            jammingInfo.push({
                room_name: room_name,
                status: status
            })
        }
        return jammingInfo;
    } catch (error) {
        console.log({ error })
        return []
    }


};